import { HistoryInfoFragment, HistoryInfoFragmentType } from '@common/graphql';
import { gql } from '@common/hooks';
import { DetailItemAttachments, DetailItemAttachmentType } from '..';

export type ComplianceItemDrawerQueryType = {
  worksListItem: {
    id: string;
    name: string;
    state: string;
    history: HistoryInfoFragmentType[];
    detailItem?: {
      id: string;
      detailItemAttachments: DetailItemAttachmentType[];
    };
    worksList: {
      id: string;
      canUpdate: {
        value: boolean;
      };
      canApproveReject: {
        value: boolean;
      };
    };
  };
};

export const ComplianceItemDrawerQuery = gql`
  query ComplianceItemDrawerQuery($id: ID!) {
    worksListItem(id: $id) {
      id
      name
      state
      worksList {
        id
        canUpdate {
          value
        }
        canApproveReject {
          value
        }
      }
      detailItem {
        ... on License {
          id
          detailItemAttachments {
            ...DetailItemAttachments
          }
        }
        ... on NurseAssessment {
          id
          detailItemAttachments {
            ...DetailItemAttachments
          }
        }
        ... on NurseHealthDoc {
          id
          detailItemAttachments {
            ...DetailItemAttachments
          }
        }
        ... on NurseCertification {
          id
          detailItemAttachments {
            ...DetailItemAttachments
          }
        }
        ... on Document {
          id
          detailItemAttachments {
            ...DetailItemAttachments
          }
        }
      }
      history {
        ...HistoryInfoFragment
      }
    }
  }
  ${HistoryInfoFragment}
  ${DetailItemAttachments}
`;
